exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n@media (min-width: 992px) {\n.custom-block[data-v-b612e4ba] {\n        color: #1a1a1a;\n        background-color: #f3f3f3;\n        padding: 20px;\n        margin-top: 20px;\n        margin-bottom: 20px;\n}\n}\n\n", ""]);
